<ion-menu contentId="main-content" menuId="lateral-menu" type="overlay" side="end">
    <ion-content>
        <ion-list id="labels-list">
            <ion-menu-toggle auto-hide="false">
                <ion-icon name="close-outline" id="close-outline"></ion-icon>
            </ion-menu-toggle>
            @for (page of pages; track page) {
            <ion-menu-toggle auto-hide="false" class="menu-item" *ngIf="!page.subItem">
                <ion-item routerDirection="root" [routerLink]="[page.url]" lines="none" detail="false">
                    <ion-label slot="end" (click)="toggleAccordion()">{{page.title}}</ion-label>
                </ion-item>
                <div class="separator" [ngClass]="page.label"></div>
            </ion-menu-toggle>
            <ion-item routerDirection="root" lines="none" detail="false" slot="end"
                *ngIf="page.subItem">
                <div class="accordion">
                    <ion-label slot="end">{{page.title}}</ion-label>
                    <ion-icon name="chevron-down-outline" [ngClass]="{'opened': isAccordionOpen}" (click)="toggleAccordion()" role="button" aria-label="Abrir/fechar submenu Trabalhe Conosco"></ion-icon>
                </div>

                <div #accordionContent>
                    <ion-list class="list-subitem" [ngClass]="{ 'accordion-open': !isAccordionOpen }">
                        @for (item of page.subItem; track item; let i = $index) {
                        <ion-menu-toggle auto-hide="false" class="menu-subitem">
                            <a [href]="item.url" target="_blank" rel="noopener noreferrer" class="external-ion-item" (click)="$event.stopPropagation()">
                                <ion-item lines="none" detail="false" button="true">
                                    <ion-label slot="end">{{ item.title }}</ion-label>
                                </ion-item>
                            </a>
                            <div class="separator" [ngClass]="item.label"></div>
                        </ion-menu-toggle>
                        }
                    </ion-list>
                </div>
            </ion-item>
            }
        </ion-list>

        @if (brands && brands.length > 0) {
        <div class="brands">
            <h2>Nossas marcas</h2>
            <ion-list id="brands-list">
            @for (brand of brands; track brand) {
                <ion-menu-toggle>
                    <ion-item (click)="navigate(brand.id, brand.tab)" [routerLink]="['/franquias/', brand.tab]" lines="none" detail="false">
                        <ion-img [src]="brand.logo.icon.src" [alt]="brand.logo.icon.alt"></ion-img>
                    </ion-item>
                </ion-menu-toggle>
                }
            </ion-list>
            <div class="cta">
                <ion-menu-toggle auto-hide="true" style="width: 79%;">
                    <app-button
                        [styles]="{color: 'var(--cinza-escuro)', backgroundColor: 'var(--amarelo-trigo)', expand: Expand.Block}"
                        [text]="'Seja nosso franqueado!'"
                        (action)="openFranchiseeForm()">
                    </app-button>
                </ion-menu-toggle>
            </div>
        </div>
        }
    </ion-content>
</ion-menu>
